module.exports = __webpack_public_path__ + "images/logo.d61a830.svg";